module.exports = __webpack_public_path__ + "img/Privacy.2ed34a0d.svg";